
import {Component, Mixins} from "vue-property-decorator";
import ObjectInputMixin from "@/mixins/ObjectInputMixin.vue";
import {RehininParayaCevrilmesiSerhiTalep} from "@/interface/IUyapTalep";

@Component({
  components: {}
})
export default class RehininParayaCevrilmesiSerhiTalepEvrakForm extends Mixins(ObjectInputMixin) {
  localValue!: RehininParayaCevrilmesiSerhiTalep;
}
